import { Navigate, Outlet } from "react-router-dom";
import useMessageTicket from "../hooks/useMessageTicket";

function ProtectedUnreadMessages() {
  const { countUnreadMessages } = useMessageTicket();

  if (countUnreadMessages > 0) {
    return <Navigate to="/messages" />;
  }

  return <Outlet />;
}
export default ProtectedUnreadMessages;
